/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AccordianContentService } from './services/accordian-content.service';
import { AccountService } from './services/account.service';
import { AppService } from './services/app.service';
import { ArticleService } from './services/article.service';
import { AuthService } from './services/auth.service';
import { BillingWorklistService } from './services/billing-worklist.service';
import { BlockContentService } from './services/block-content.service';
import { CardContentService } from './services/card-content.service';
import { CareerService } from './services/career.service';
import { CircularContentService } from './services/circular-content.service';
import { ClientContentService } from './services/client-content.service';
import { CndnRequestService } from './services/cndn-request.service';
import { CompanyService } from './services/company.service';
import { ContactusContentService } from './services/contactus-content.service';
import { ContentService } from './services/content.service';
import { CookieService } from './services/cookie.service';
import { CorporateService } from './services/corporate.service';
import { CourseService } from './services/course.service';
import { CourseRequestService } from './services/course-request.service';
import { CourseTypeService } from './services/course-type.service';
import { DepartmentService } from './services/department.service';
import { DeviceService } from './services/device.service';
import { EmailTemplateService } from './services/email-template.service';
import { FeedbackService } from './services/feedback.service';
import { FieldService } from './services/field.service';
import { FieldMappingService } from './services/field-mapping.service';
import { FileService } from './services/file.service';
import { FileSteamService } from './services/file-steam.service';
import { GroupService } from './services/group.service';
import { HeaderFooterService } from './services/header-footer.service';
import { ImageContentService } from './services/image-content.service';
import { InvoiceRequestService } from './services/invoice-request.service';
import { LicenseTypeService } from './services/license-type.service';
import { MenuService } from './services/menu.service';
import { MigrationService } from './services/migration.service';
import { OicService } from './services/oic.service';
import { PageService } from './services/page.service';
import { PrefixService } from './services/prefix.service';
import { PromotionCodeService } from './services/promotion-code.service';
import { ProvinceService } from './services/province.service';
import { ReceiptRequestService } from './services/receipt-request.service';
import { ReportService } from './services/report.service';
import { RoleService } from './services/role.service';
import { ServerService } from './services/server.service';
import { StatContentService } from './services/stat-content.service';
import { SubMenuService } from './services/sub-menu.service';
import { TagService } from './services/tag.service';
import { TestimonialContentService } from './services/testimonial-content.service';
import { TextImageContentService } from './services/text-image-content.service';
import { ThirdPartyNetworkService } from './services/third-party-network.service';
import { TimelineContentService } from './services/timeline-content.service';
import { TrainingService } from './services/training.service';
import { TrustedCompanyContentService } from './services/trusted-company-content.service';
import { UserService } from './services/user.service';
import { WorklistService } from './services/worklist.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AccordianContentService,
    AccountService,
    AppService,
    ArticleService,
    AuthService,
    BillingWorklistService,
    BlockContentService,
    CardContentService,
    CareerService,
    CircularContentService,
    ClientContentService,
    CndnRequestService,
    CompanyService,
    ContactusContentService,
    ContentService,
    CookieService,
    CorporateService,
    CourseService,
    CourseRequestService,
    CourseTypeService,
    DepartmentService,
    DeviceService,
    EmailTemplateService,
    FeedbackService,
    FieldService,
    FieldMappingService,
    FileService,
    FileSteamService,
    GroupService,
    HeaderFooterService,
    ImageContentService,
    InvoiceRequestService,
    LicenseTypeService,
    MenuService,
    MigrationService,
    OicService,
    PageService,
    PrefixService,
    PromotionCodeService,
    ProvinceService,
    ReceiptRequestService,
    ReportService,
    RoleService,
    ServerService,
    StatContentService,
    SubMenuService,
    TagService,
    TestimonialContentService,
    TextImageContentService,
    ThirdPartyNetworkService,
    TimelineContentService,
    TrainingService,
    TrustedCompanyContentService,
    UserService,
    WorklistService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
